module.exports = __webpack_public_path__ + "static/media/monk.59711b77.jpg";